import { createContext } from 'react';
import type { ConfirmTone } from '../ui/ConfirmDialog';

export type ConfirmationOptions = {
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  tone?: ConfirmTone;
  /**
   * Quando `true`, usa tone='danger' por default. Atalho idiomático
   * pra ações destrutivas (excluir, cancelar agendamento, etc.).
   */
  danger?: boolean;
};

export type ConfirmationContextValue = {
  confirm: (options: ConfirmationOptions) => Promise<boolean>;
};

export const ConfirmationContext = createContext<ConfirmationContextValue | null>(null);
